export class PlayersAnswer {
  _id: string;
  playerID: string;
  questionID: string;
  answerArray: {
    answerLabel_fi: string,
    answerLabel_sv: string,
    answerLabel_en: string,
    score: number
  }[];
}



// WEBPACK FOOTER //
// ./src/app/players-answer.ts